import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";

export const systemStatus: FieldSchema = {
  name: "systemStatus",
  grid: {
    displayed: true,
    order: 56,
  },
  data: { variant: DataVariants.ENUM, options: ["In service", "Out of service"] },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: { label: "Equipment status", type: InputTypes.SELECT },
};
